module.exports = __webpack_public_path__ + "static/media/branch.0c9790e9.svg";